import React from 'react';
import { ElementsPlug} from '@arrival/elements-plug-page'
import './app.css'

function App() {
  return (
    <ElementsPlug title='We are getting better.' subtitle='Website is under maintenance.' />
  );
}

export default App;
